import type { ComponentProps } from 'preact';

type IconInSprite =
  | 'apple-logo'
  | 'close-circle'
  | 'close'
  | 'down-arrow'
  | 'feedback'
  | 'forward-30'
  | 'google-g'
  | 'headphones'
  | 'loading-circle'
  | 'mic'
  | 'pause'
  | 'play-later'
  | 'play'
  | 'plus-circle'
  | 'checkmark-circle'
  | 'replay-10'
  | 'rss-error'
  | 'search'
  | 'sort'
  | 'user-minus'
  | 'user'
  | 'queue-top'
  | 'unqueue-top'
  | 'drag-up-down'
  | 'moon-zzzs';

export function Icon(
  props: ComponentProps<'svg'> & ({ sprite: IconInSprite } | { href: string })
) {
  const href = 'href' in props ? props.href : `/icons-sprite#${props.sprite}`;
  return (
    <svg {...props}>
      <use href={href} />
    </svg>
  );
}
